import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { IdChip } from '@/components/ui';

export type SubjectKind = 'location' | 'conversation' | 'message' | 'draft' | 'mailbox_connector' | 'job' | 'saved_view' | 'run' | 'session';

/** App path for an object id. Returns undefined when no page exists for that kind. */
export function subjectHref(kind: SubjectKind, id: string): string | undefined {
  switch (kind) {
    case 'location':
      return `/app/board/${id}`;
    case 'conversation':
      return `/app/conversations/${id}`;
    case 'draft':
      // Resolves to the draft's conversation.
      return `/app/outbox/${id}`;
    case 'mailbox_connector':
      return '/app/settings/mailbox';
    case 'job':
      return '/app/settings/agents/jobs';
    case 'run':
      return `/app/settings/agents/runs/${id}`;
    case 'session':
      return `/app/settings/agents/sessions/${id}`;
    default:
      return undefined;
  }
}

/** Link to an object by id; falls back to the id chip when the kind has no page. */
export function ObjectLink({ kind, id, children }: { kind: SubjectKind; id: string | null | undefined; children?: ReactNode }) {
  if (!id) return <span className="faint">None</span>;
  const href = subjectHref(kind, id);
  if (!href) return <IdChip id={id} />;
  return <Link to={href}>{children ?? <IdChip id={id} />}</Link>;
}
